import type { PropertyFeatureConfig } from '../../../types/insurances/PropertyFeatureConfig';

export const property: PropertyFeatureConfig = {
    overview: {
        details: {
            showVariant: false,
            showPackage: false,
            showContractHolder: true,
            showContractNumber: true,
            fallbackAssistancePhonesKey: 'HR',
            fallbackAssistanceEmailsKey: 'HR',
        },
        propertySubjects: {
            showSimplifiedAddress: false,
        },
        showLinkedLoans: false,
    },
    history: {
        visible: false,
    },
    settings: {
        details: {
            showStatus: false,
        },
    },
};
